import { useApi } from '@/api';
import { KpiCard, KpiSkeleton } from '@/components';
import { Flex } from '@blockanalitica/ui';

export default function OverviewKpis({ daysAgo }) {
  const [data, error] = useApi({
    url: '/rwa/overview/',
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
        <KpiCard
          title="Total Deployed"
          data={data}
          variant="dai"
          field="debt"
          options={{
            trend: true,
            valueOptions: {
              currencyValueOptions: {
                currency: {
                  name: data.debt_symbol,
                  address: data.debt_address
                },
                iconSize: '3'
              }
            }
          }}
        />
      </Flex>
    );
  }

  return (
    <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
      <KpiSkeleton />
      <KpiSkeleton />
    </Flex>
  );
}
